import React from "react";
import config from "../../configuration/config";

import {
  withTheme,
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  TextField,
  withStyles,
  InputAdornment,
  InputBase,
  InputLabel,
  Button,
  List,
  ListItem,
  Divider,
  CircularProgress,
  Collapse,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import {
  Close,
  Edit,
  Search,
  LocationOn,
  ExpandLess,
  ExpandMore,
  AttachMoney,
} from "@material-ui/icons";
// import Swipe from 'react-easy-swipe'
import s from "./account.module.css";
// import { theme } from '../../framework/theme'
import GlobalContext from "../../context/globalContext";
import PropTypes from "prop-types";
import { styles } from "./style";
import MaskedInput from "react-text-mask";
import { isAndroid } from "react-device-detect";
// import ReactMapboxGl from "react-mapbox-gl";
import { isAlpha } from "validator";
import _ from "lodash";

// import { isPointWithinRadius } from "geolib";
import moment from "moment";

function Transition(props) {
  return <Slide direction="left" {...props} />;
}

//MAPBOX
const mbxGeocoding = require("@mapbox/mapbox-sdk/services/geocoding");
const geocodingClient = mbxGeocoding({ accessToken: config.mapbox.key });

class Account extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      phone: "",

      firstNameEdit: true,
      lastNameEdit: true,
      phoneEdit: true,

      phoneError: false,
      emailError: false,
      labelText: "email",

      userUpToDate: true,

      mapboxNewLocationDialogOpen: false,
      mapboxSelectedLocation: null,
      searchCustomerLocationInput: "",
      suggestionList: null,
      address2: "",
      creatingUserLocation: false,
      userLocation: null,
      userLocationAttempted: false,

      creditCollapseOpen: false,
      userCollapseOpen: false,
    };
  }

  async componentDidMount() {
    if (this.context.global.data.user) {
      const { user } = this.context.global.data;
      this.setState({
        firstName: user.firstName,
        lastName: user.lastName,
        phone: user.phone,
      });
    } else {
      let user = await this.context.global.getUserByUuid();
      this.setState({
        firstName: user.firstName,
        lastName: user.lastName,
        phone: user.phone,
      });
    }
  }

  closeAccountDialog = () => {
    // this.context.global.setGlobalState('accountDialogState', false)
    this.setState({
      firstNameEdit: true,
      lastNameEdit: true,
      phoneEdit: true,
      userLocationAttempted: false,
      userLocation: null,
    });
    this.forceUpdate();
    this.context.global.handleDashboardActions("BACK", "accountDialogState");
    this.context.global.getUserByUuid();
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      userUpToDate: false,
    });
  };

  handleChangeId = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  toggleEdit = (key, value) => {
    this.setState({ [key]: value });
    if (value === true && this.state.userUpToDate === false) {
      this.saveChanges();
    }
  };

  saveChanges = async () => {
    const cleanedPhoneNumber = this.state.phone.replace(/\D+/g, "");
    this.context.global.patchUser({
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      phone: cleanedPhoneNumber,
    });
    this.setState({ userUpToDate: true });
  };

  logout = () => {
    this.context.global.logout();
  };

  handleSearchMapBoxChange = async (event) => {
    this.setState({ [event.target.id]: event.target.value });
    await geocodingClient
      .forwardGeocode({
        query: event.target.value,
        countries: ["US"],
        limit: 5,
      })
      .send()
      .then((response) => {
        let displayLocations = [];
        for (let i in response.body.features) {
          let location = response.body.features[i];
          let formattedLocation = {};
          let customerLocation = {};
          if (location.place_type.includes("address")) {
            let splitAddressArray = location.place_name.split(",");
            formattedLocation.address1 = splitAddressArray[0];
            formattedLocation.city = splitAddressArray[1];
            formattedLocation.state = abbrRegion(
              splitAddressArray[2].slice(1, -6),
              "TO_ABBREVIATED"
            );
            formattedLocation.zip = splitAddressArray[2].substr(-5);
            location.displayAddress = formattedLocation;
            customerLocation = { ...location };
            displayLocations.push(customerLocation);
          }
        }
        this.setState({ suggestionList: displayLocations });
      });

    // window.scrollTo(0, document.body.scrollHeight)
  };

  setInitialUserLocation = (user) => {
    if (user.locations.length > 0) {
      let primary = user.locations.find((i) => i.isPrimary === 1);
      if (primary) {
        this.setState({ userLocation: primary });
      } else {
        let location = _.head(
          user.locations.sort((a, b) => a.created - b.created)
        );
        this.setState({ userLocation: location });
      }
    } else {
      this.setState({ userLocationAttempted: true });
    }
  };

  selectUserLocation = (location) => {
    let customerLocation = {};
    let formattedLocation = {};
    if (location.place_name) {
      let splitAddressArray = location.place_name.split(",");
      formattedLocation.address1 = splitAddressArray[0];
      formattedLocation.city = splitAddressArray[1];
      formattedLocation.state = abbrRegion(
        splitAddressArray[2].slice(1, -6),
        "TO_ABBREVIATED"
      );
      formattedLocation.zip = splitAddressArray[2].substr(-5);
      customerLocation = { ...location, ...formattedLocation };
      delete customerLocation.type;
    }

    customerLocation.mapboxId = location.id;

    if (location.latitude && location.longitude) {
      customerLocation.longitude = location.longitude;
      customerLocation.latitude = location.latitude;
    } else if (location.center && location.center.length > 1) {
      customerLocation.longitude = location.center[0];
      customerLocation.latitude = location.center[1];
    } else if (
      (!location.center || location.center.length < 1) &&
      location.geometry &&
      location.geometry.center
    ) {
      customerLocation.longitude = location.geometry.center[0];
      customerLocation.latitude = location.geometry.center[1];
    } else {
      return console.log("NO COORDINATE", location);
    }

    this.setState({ mapboxSelectedLocation: customerLocation });
  };

  createUserLocation = async () => {
    let { mapboxSelectedLocation, address2 } = this.state;
    mapboxSelectedLocation.address2 = address2;
    this.setState({ creatingUserLocation: true });
    let location = await this.context.global.createUserLocation(
      mapboxSelectedLocation
    );
    this.setState({
      creatingUserLocation: false,
      mapboxNewLocationDialogOpen: false,
      userLocation: location,
      mapboxSelectedLocation: null,
      searchCustomerLocationInput: "",
      suggestionList: null,
    });
    this.updateDeliveryLocation();
  };

  updateDeliveryLocation = async () => {
    this.context.global.updateDeliveryLocation(this.state.userLocation);
  };

  expandCredit = () => {
    this.setState({ creditCollapseOpen: !this.state.creditCollapseOpen });
  };

  expandUser = () => {
    this.setState({ userCollapseOpen: !this.state.userCollapseOpen });
  };

  render() {
    const {
      firstName,
      lastName,
      phone,

      firstNameEdit,
      lastNameEdit,
      phoneEdit,

      userUpToDate,

      mapboxNewLocationDialogOpen,
      mapboxSelectedLocation,
      searchCustomerLocationInput,
      suggestionList,
      address2,
      creatingUserLocation,
      // userLocation,
      creditCollapseOpen,
      userCollapseOpen,
    } = this.state;
    const { classes, theme } = this.props;
    const { accountDialogState, user } = this.context.global.data;

    // let hideButton = true;

    // if (!userLocation && user && !userLocationAttempted) {
    //   this.setInitialUserLocation(user);
    // }

    if (!user) {
      return null;
    }

    let userLocation;
    if (user && user.locations.length > 0) {
      let primary = user.locations.find((i) => i.isPrimary === 1);
      if (primary) {
        userLocation = primary;
      } else {
        let location = _.head(
          user.locations.sort((a, b) => a.created - b.created)
        );
        userLocation = location;
      }
    }

    // if (
    //   userLocation &&
    //   shoppingCart &&
    //   shoppingCart.deliveryLocation &&
    //   shoppingCart.deliveryLocation.latitude
    // ) {
    //   let test = isPointWithinRadius(
    //     { latitude: userLocation.latitude, longitude: userLocation.longitude },
    //     {
    //       latitude: shoppingCart.deliveryLocation.latitude,
    //       longitude: shoppingCart.deliveryLocation.longitude,
    //     },
    //     shoppingCart.popUpLocationInstance.deliveryRadiusMiles * 1609.34
    //   );

      // if (test) {
      //   if (userLocation.mapboxId != shoppingCart.deliveryLocation.mapboxId) {
      //     hideButton = false;
      //   }
      // } else hideButton = true;
    // }

    return (
      <>
        <Dialog
          fullScreen
          open={accountDialogState}
          onClose={this.closeAccountDialog}
          TransitionComponent={Transition}
          scroll={"paper"}
          style={{ zIndex: 90002 }}
        >
          <AppBar className={s.accountAppBar}>
            <Toolbar className={s.accountToolbar}>
              <div className={s.accountAppBarContentContainer}>
                <div className={s.accountAddressContainer}>
                  <Typography variant="body1" style={{ color: "white" }}>
                    Account Information
                  </Typography>
                </div>
              </div>
              <div className={s.accountCloseButtonContainer}>
                <IconButton
                  color="inherit"
                  onClick={this.closeAccountDialog}
                  aria-label="Close"
                  className={s.accountAppBar}
                >
                  <Close />
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
          <div className={classes.content}>
            <div className={classes.middle}>
              <div
                className={s.account_dataLines}
                style={{ marginBottom: "8px" }}
              >
                <Typography variant="subtitle1" style={{ marginBottom: "5px" }}>
                  User name / email
                </Typography>

                <Typography variant="subtitle1">
                  {user ? user.email : null}
                </Typography>
              </div>

              <Divider />

              <ListItem button onClick={this.expandUser} style={userCollapseOpen ? {backgroundColor: "white"}: null}>
                <ListItemIcon>
                  <Edit />
                </ListItemIcon>
                <ListItemText primary="User Information" />
                {userCollapseOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={userCollapseOpen}
                timeout="auto"
                unmountOnExit
                className={s.creditCollapseContainer}
              >
                <Divider />

                <div className={s.account_dataLines}>
                  {!firstNameEdit ? (
                    <TextField
                      name={"firstName"}
                      placeholder={"first name"}
                      value={firstName}
                      error={false}
                      label={"first name"}
                      onChange={(event) => {
                        this.handleChange(event);
                      }}
                      onBlur={() =>
                        this.toggleEdit("firstNameEdit", !firstNameEdit)
                      }
                      autoCapitalize="none"
                      autoCorrect="none"
                      // margin="normal"
                      disabled={firstNameEdit}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                this.toggleEdit("firstNameEdit", !firstNameEdit)
                              }
                            >
                              {<Edit />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <InputLabel shrink>first name</InputLabel>
                      <InputBase
                        name={"firstName"}
                        placeholder={"first name"}
                        value={firstName}
                        // margin="normal"
                        disabled={true}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                this.toggleEdit("firstNameEdit", !firstNameEdit)
                              }
                            >
                              {<Edit />}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </div>
                  )}
                </div>
                <Divider />

                <div className={s.account_dataLines}>
                  {!lastNameEdit ? (
                    <TextField
                      name={"lastName"}
                      placeholder={"last name"}
                      value={lastName}
                      error={false}
                      label={"last name"}
                      onChange={(event) => {
                        this.handleChange(event);
                      }}
                      onBlur={() =>
                        this.toggleEdit("lastNameEdit", !lastNameEdit)
                      }
                      autoCapitalize="none"
                      autoCorrect="none"
                      // margin="normal"
                      disabled={lastNameEdit}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                this.toggleEdit("lastNameEdit", !lastNameEdit)
                              }
                            >
                              {<Edit />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <InputLabel shrink>last name</InputLabel>
                      <InputBase
                        name={"lastName"}
                        placeholder={"last name"}
                        value={lastName}
                        // margin="normal"
                        disabled={true}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                this.toggleEdit("lastNameEdit", !lastNameEdit)
                              }
                            >
                              {<Edit />}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </div>
                  )}
                </div>
                <Divider />

                <div className={s.account_dataLines}>
                  {!phoneEdit ? (
                    <TextField
                      name={"phone"}
                      placeholder={"phone"}
                      value={phone}
                      error={false}
                      label={"phone"}
                      onChange={(event) => {
                        this.handleChange(event);
                      }}
                      onBlur={() => this.toggleEdit("phoneEdit", !phoneEdit)}
                      autoCapitalize="none"
                      autoCorrect="none"
                      // margin="normal"
                      disabled={phoneEdit}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                this.toggleEdit("phoneEdit", !phoneEdit)
                              }
                            >
                              {<Edit />}
                            </IconButton>
                          </InputAdornment>
                        ),
                        inputComponent: TextMaskCustom,
                        type: "tel",
                      }}
                    />
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <InputLabel shrink>phone</InputLabel>
                      <InputBase
                        name={"phone"}
                        placeholder={"phone #"}
                        value={phone}
                        // margin="normal"
                        disabled={true}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                this.toggleEdit("phoneEdit", !phoneEdit)
                              }
                            >
                              {<Edit />}
                            </IconButton>
                          </InputAdornment>
                        }
                        inputComponent={TextMaskCustom}
                      />
                    </div>
                  )}
                </div>
                <Divider />

                <div className={s.account_dataLines}>
                  <Typography
                    variant={"body2"}
                    style={{ color: "rgba(0, 0, 0, 0.40)" }}
                  >
                    delivery address
                  </Typography>
                  <div className={s.account_delivery_address_container}>
                    {userLocation ? (
                      <div className={s.account_delivery_address_text}>
                        <Typography
                          variant={"body2"}
                          style={{ color: "rgba(0, 0, 0, 0.40)" }}
                        >
                          {userLocation.address1}
                        </Typography>
                        <Typography
                          variant={"body2"}
                          style={{ color: "rgba(0, 0, 0, 0.40)" }}
                        >
                          {userLocation.address2}
                        </Typography>
                        <Typography
                          variant={"body2"}
                          style={{ color: "rgba(0, 0, 0, 0.40)" }}
                        >
                          {userLocation.city} {userLocation.state}{" "}
                          {userLocation.zip}
                        </Typography>
                      </div>
                    ) : null}
                    <IconButton
                      style={{ padding: "0 12px 0 0" }}
                      onClick={() => {
                        this.context.global.handleOpenNewUserDeliveryLocationDialog();
                      }}
                    >
                      {<Edit />}
                    </IconButton>
                  </div>
                </div>
              <Divider />

              </Collapse>

              <Divider />

              <ListItem button onClick={this.expandCredit} style={creditCollapseOpen ? {backgroundColor: "white"}: null}>
                <ListItemIcon>
                  <AttachMoney />
                </ListItemIcon>
                <ListItemText
                  primary="Credits / Gifts"
                  secondary={`Balance : $ ${(
                    user.credits.totalCredit / 100
                  ).toFixed(2)}`}
                />
                {creditCollapseOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={creditCollapseOpen}
                timeout="auto"
                unmountOnExit
                className={s.creditCollapseContainer}
              >
                <Divider />

                {user.credits.credits
                  .sort(function (a, b) {
                    return a.givenAtTimestamp - b.givenAtTimestamp;
                  })
                  .map((credit) => {
                    const creditDate = moment
                      .unix(credit.givenAtTimestamp)
                      .format("lll");
                    return (
                      <>
                        <ListItem>
                          <ListItemText
                            primary={`$ ${(credit.amount / 100).toFixed(2)} - ${
                              credit.isAnonymous
                                ? "Anonymous"
                                : credit.fromEmail
                            }`}
                            secondary={creditDate}
                          />
                        </ListItem>
                        <Divider />
                      </>
                    );
                  })}
              </Collapse>

              <Divider />

              {/* {hideButton ? null : (
                <>
                  <Button onClick={this.updateDeliveryLocation}>Make Delivery Location for Current Shopping Cart</Button>

                  <Divider style={{ margin: 10 }} />
                </>
              )} */}

              {userUpToDate ? null : (
                <Button
                  onClick={async () => this.saveChanges()}
                  disabled={userUpToDate}
                >
                  Save Changes
                </Button>
              )}
            </div>
            <div className={classes.bottom}>
              <Button
                style={{
                  background: `linear-gradient(0.91turn, #e88e86 1%, #870b00 99%)`,
                }}
                onClick={async () => this.logout()}
              >
                Logout
              </Button>
              <div className={s.legalLine}>
                <p
                  onClick={() => this.props.history.push("/privacy-policy")}
                  style={{
                    textDecoration: "underline",
                    textAlign: "center",
                    fontFamily: "Montserrat",
                    marginTop: 20,
                    marginBottom: 0,
                    fontSize: 12,
                    maxWidth: 100,
                    alignSelf: "center",
                  }}
                >
                  Privacy Policy
                </p>
                <p
                  style={{
                    textDecoration: "underline",
                    textAlign: "center",
                    fontFamily: "Montserrat",
                    marginTop: 20,
                    marginBottom: 0,
                    fontSize: 12,
                    maxWidth: 100,
                    alignSelf: "center",
                  }}
                >
                  |
                </p>
                <p
                  onClick={() => this.props.history.push("/terms-of-service")}
                  style={{
                    textDecoration: "underline",
                    textAlign: "center",
                    fontFamily: "Montserrat",
                    marginTop: 20,
                    marginBottom: 0,
                    fontSize: 12,
                    maxWidth: 100,
                    alignSelf: "center",
                  }}
                >
                  Terms of Service
                </p>
              </div>
            </div>
            {isAndroid ? <div style={{ height: "200%" }} /> : null}
          </div>
        </Dialog>

        <Dialog
          fullWidth
          open={mapboxNewLocationDialogOpen}
          onClose={() => this.setState({ mapboxNewLocationDialogOpen: false })}
          maxWidth={false}
        >
          <div className={s.findHotSpotZip_mapboxNewLocationDialog_outer}>
            {!mapboxSelectedLocation ? (
              <>
                <Typography>What address?</Typography>

                <TextField
                  multiline
                  autoFocus
                  fullWidth
                  id="searchCustomerLocationInput"
                  // label="delivery address"
                  value={searchCustomerLocationInput}
                  onChange={this.handleSearchMapBoxChange.bind(this)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment
                        onClick={() =>
                          this.setState({
                            searchCustomerLocationInput: "",
                            suggestionList: null,
                          })
                        }
                        position="end"
                      >
                        <Close />
                      </InputAdornment>
                    ),
                  }}
                />

                {suggestionList ? (
                  <>
                    <List>
                      {suggestionList.map((loc) => {
                        return (
                          <>
                            <ListItem
                              className={classes.userLocationListItem}
                              Button
                              onClick={async () => {
                                await this.selectUserLocation(loc);
                                // await this.setState({
                                //   mapboxNewLocationDialogOpen: false
                                // })
                              }}
                            >
                              <LocationOn
                                style={{
                                  color: theme.palette.primary.main,
                                  paddingRight: 5,
                                }}
                              />
                              <Typography variant={"body2"}>
                                {loc.displayAddress.address1}
                                <Typography variant={"caption"}>
                                  {loc.displayAddress.city} {" , "}{" "}
                                  {loc.displayAddress.state}
                                </Typography>
                              </Typography>
                            </ListItem>
                            <Divider />
                          </>
                        );
                      })}
                    </List>
                  </>
                ) : null}
              </>
            ) : null}
            {mapboxSelectedLocation ? (
              <div className={s.availability_customerNewLocationDialog_inner}>
                <div
                  className={s.availability_customerNewLocationDialog_inner_top}
                >
                  <Typography>Selected Address</Typography>

                  <div className={s.dialogRow}>
                    <div className={s.dialogRowContainer}>
                      <div className={s.dialogRowLeft}>
                        <LocationOn
                          style={{
                            color: theme.palette.primary.main,
                          }}
                        />
                      </div>
                      <div className={s.dialogRowRight}>
                        {/* <div className={s.dialogHeader}>{userLocation && userLocation.place_name ? userLocation.place_name : (userLocation.name - userLocation.address1, userLocation.zip)}</div> */}
                        <div className={s.dialogSubHeader}>
                          <div>{mapboxSelectedLocation.address1}</div>
                          <div>{mapboxSelectedLocation.address2}</div>
                          <div>
                            {mapboxSelectedLocation.city}{" "}
                            {mapboxSelectedLocation.state}{" "}
                            {mapboxSelectedLocation.zip}
                          </div>
                        </div>
                      </div>
                      <p
                        onClick={() =>
                          this.setState({ mapboxSelectedLocation: null })
                        }
                        style={{
                          textDecoration: "underline",
                          textAlign: "right",
                          fontFamily: "Montserrat",
                          fontSize: 12,
                        }}
                      >
                        Change
                      </p>
                    </div>
                  </div>
                  <div
                    className={s.dialogSubHeader}
                    style={{ textAlign: "center" }}
                  >
                    Is there anything your driver should know about this
                    address? Apartment number, gate or door code?
                  </div>

                  <TextField
                    multiline
                    autoFocus
                    fullWidth
                    id="address2"
                    helperText="(e.g. APT 123, Unit A, Passcode 1234)"
                    value={address2}
                    onChange={this.handleChangeId.bind(this)}
                  />
                </div>

                <Typography>If not click to continue</Typography>

                <Button
                  disabled={(() => {
                    if (creatingUserLocation) {
                      return true;
                    }
                  })()}
                  style={{ minHeight: 70, width: "100%", marginTop: 10 }}
                  onClick={async () => {
                    await this.createUserLocation();
                  }}
                >
                  {creatingUserLocation ? (
                    <CircularProgress style={{ height: 25, width: 25 }} />
                  ) : (
                    "Update Delivery Location"
                  )}
                </Button>
              </div>
            ) : null}
          </div>
        </Dialog>
      </>
    );
  }
}

Account.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTheme()(withStyles(styles)(Account));

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      keepCharPositions={true}
      mask={[
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      // showMask
    />
  );
}

function abbrRegion(input, to) {
  var states = [
    ["Alabama", "AL"],
    ["Alaska", "AK"],
    ["American Samoa", "AS"],
    ["Arizona", "AZ"],
    ["Arkansas", "AR"],
    ["Armed Forces Americas", "AA"],
    ["Armed Forces Europe", "AE"],
    ["Armed Forces Pacific", "AP"],
    ["California", "CA"],
    ["Colorado", "CO"],
    ["Connecticut", "CT"],
    ["Delaware", "DE"],
    ["District Of Columbia", "DC"],
    ["Florida", "FL"],
    ["Georgia", "GA"],
    ["Guam", "GU"],
    ["Hawaii", "HI"],
    ["Idaho", "ID"],
    ["Illinois", "IL"],
    ["Indiana", "IN"],
    ["Iowa", "IA"],
    ["Kansas", "KS"],
    ["Kentucky", "KY"],
    ["Louisiana", "LA"],
    ["Maine", "ME"],
    ["Marshall Islands", "MH"],
    ["Maryland", "MD"],
    ["Massachusetts", "MA"],
    ["Michigan", "MI"],
    ["Minnesota", "MN"],
    ["Mississippi", "MS"],
    ["Missouri", "MO"],
    ["Montana", "MT"],
    ["Nebraska", "NE"],
    ["Nevada", "NV"],
    ["New Hampshire", "NH"],
    ["New Jersey", "NJ"],
    ["New Mexico", "NM"],
    ["New York", "NY"],
    ["North Carolina", "NC"],
    ["North Dakota", "ND"],
    ["Northern Mariana Islands", "NP"],
    ["Ohio", "OH"],
    ["Oklahoma", "OK"],
    ["Oregon", "OR"],
    ["Pennsylvania", "PA"],
    ["Puerto Rico", "PR"],
    ["Rhode Island", "RI"],
    ["South Carolina", "SC"],
    ["South Dakota", "SD"],
    ["Tennessee", "TN"],
    ["Texas", "TX"],
    ["US Virgin Islands", "VI"],
    ["Utah", "UT"],
    ["Vermont", "VT"],
    ["Virginia", "VA"],
    ["Washington", "WA"],
    ["West Virginia", "WV"],
    ["Wisconsin", "WI"],
    ["Wyoming", "WY"],
  ];

  // So happy that Canada and the US have distinct abbreviations
  var provinces = [
    ["Alberta", "AB"],
    ["British Columbia", "BC"],
    ["Manitoba", "MB"],
    ["New Brunswick", "NB"],
    ["Newfoundland", "NF"],
    ["Northwest Territory", "NT"],
    ["Nova Scotia", "NS"],
    ["Nunavut", "NU"],
    ["Ontario", "ON"],
    ["Prince Edward Island", "PE"],
    ["Quebec", "QC"],
    ["Saskatchewan", "SK"],
    ["Yukon", "YT"],
  ];

  var regions = states.concat(provinces);

  var i; // Reusable loop variable
  if (to === "TO_ABBREVIATED") {
    if (isAlpha && input.length === 2) {
      return input;
    } else {
      input = input.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      for (i = 0; i < regions.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (regions[i][0] == input) {
          return regions[i][1];
        }
      }
    }
  } else if (to === "TO_NAME") {
    input = input.toUpperCase();
    for (i = 0; i < regions.length; i++) {
      // eslint-disable-next-line eqeqeq
      if (regions[i][1] == input) {
        return regions[i][0];
      }
    }
  }
}
